import { useMemo } from 'react';
import { useClientUser } from '@/hooks/useClientUser';

// The client's resources keyed by resource_id. Read from useClientUser rather than a route's own
// `resource`: ROUTE_FIELDS projects ResourceFleetFields, which carries the capacity columns but
// neither the recurrence rules nor the per-day overrides the shutoff gate and day state read.
export const useResourcesById = () => {
    const { resources } = useClientUser();

    return useMemo(
        () => Object.fromEntries((resources || []).map((resource) => [resource.resource_id, resource])),
        [resources]
    );
};
